import { useState, useEffect, createElement, Fragment } from 'react';
export function useClientOnly() {
  var _useState = useState(false),
    isClient = _useState[0],
    setIsClient = _useState[1];
  useEffect(function () {
    setIsClient(true);
  }, []);
  return isClient;
}
export function ClientOnly(_ref) {
  var children = _ref.children,
    _ref$fallback = _ref.fallback,
    fallback = _ref$fallback === void 0 ? null : _ref$fallback;
  var isClient = useClientOnly();
  if (!isClient) {
    return fallback;
  }
  return /*#__PURE__*/createElement(Fragment, {}, children);
}